import { useDialogState } from "../../hooks/use-dialog-state/UseDialogState";
import { UICustomizationSettingsDialogState } from "./UICustomizationSettingsDialog";

export function useUICustomizationSettingsDialogState(): UICustomizationSettingsDialogState {
    return useDialogState();
}